import { SxProps, Theme } from '@mui/material';

export const containerBox: SxProps<Theme> = {
  mb: 2,
  px: 2,
  pt: 2,
};

export const captionText: SxProps<Theme> = {
  color: 'text.secondary',
  mb: 0.5,
  display: 'block',
};

export const getToggleButtonGroupStyles = (): SxProps<Theme> => ({
  '& .MuiToggleButton-root': {
    color: 'primary.main',
    borderColor: 'primary.main',
    px: 2,
    '&:hover': {
      backgroundColor: 'action.hover',
    },
    '&.Mui-selected': {
      color: 'white',
      backgroundColor: 'primary.main',
      borderColor: 'primary.main',
      '&:hover': {
        backgroundColor: 'primary.dark',
        borderColor: 'primary.dark',
      },
    },
  },
});
